import(/* webpackMode: "eager" */ "/app/app/(default)/terms/page.jsx");
